// @flow

import type { FluxStandardAction } from 'flux-standard-action';

import clean from 'src/modules/clean-object';

import {
  getMetaDescription as generateMetaDescription,
  canonicaliseUrl
} from '@seek/seek-jobs-seo';

export const Actions = {
  GET_META_DESCRIPTION: 'GET_META_DESCRIPTION',
  SET_CANONICAL_URL: 'SET_CANONICAL_URL'
};

export type ActionType = $Keys<typeof Actions>;

type State = {
  metaDescription: ?string,
  canonicalUrl: ?string,
  partners: {
    canCrossLink: boolean
  }
};

type Payload = {
  metaDescription?: string,
  canonical?: string
};

type Action = FluxStandardAction<ActionType, Payload, Object>;

const initialState: State = {
  metaDescription: null,
  canonicalUrl: null,
  partners: {
    canCrossLink: false
  }
};

const reducer = (state: State = initialState, action: Action): State => {
  const { type, payload = {} } = action;

  switch (type) {
    case Actions.GET_META_DESCRIPTION: {
      const { metaDescription } = payload;

      return { ...state, metaDescription };
    }

    case Actions.SET_CANONICAL_URL: {
      const { canonical: canonicalUrl } = payload;

      return { ...state, canonicalUrl };
    }

    default:
      return state;
  }
};

export const getMetaDescription = ({
  locale,
  path
}: {
  locale: Locale,
  path: string
}) => (dispatch: *, getState: *) => {
  const {
    search: { query },
    results: { totalCount, location }
  } = getState();

  const metaDescription = generateMetaDescription(
    clean({
      locale,
      path,
      query,
      totalCount,
      location
    })
  );

  dispatch({
    type: Actions.GET_META_DESCRIPTION,
    payload: { metaDescription }
  });
};

export const setCanonicalUrl = ({ locale, path, query }: *) => (
  dispatch: *,
  getState: *
) => {
  const { results: resultsStore } = getState();
  const { location, canonicalCompany } = resultsStore;

  const canonicalisation = canonicaliseUrl({
    locale,
    path,
    query,
    location,
    searchMeta: { canonicalCompany }
  });

  dispatch({
    type: Actions.SET_CANONICAL_URL,
    payload: canonicalisation
  });
};

export default reducer;
